'use client'
import { useState, useEffect, useCallback } from 'react'

interface ErrorInfo {
  message: string
  isVisible: boolean
}

export const useError = () => {
  const [globalErrorInfo, setGlobalErrorInfo] = useState<ErrorInfo>({
    message: '',
    isVisible: false
  })

  const dismissGlobalError = useCallback(() => {
    setGlobalErrorInfo(prev => ({ ...prev, isVisible: false }))
  }, [])

  const handleError = useCallback((message: string) => {
    setGlobalErrorInfo({ message, isVisible: true })
  }, [])

  useEffect(() => {
    const handleRejection = (event: PromiseRejectionEvent) => {
      const message: string = event.reason?.message ?? ''
      const digest: string = event.reason?.digest ?? ''
      if (message.includes('NEXT_REDIRECT') || digest.startsWith('NEXT_REDIRECT')) {
 return
}
      handleError(message || 'An unexpected async error occurred.')
    }

    const handleRuntimeError = (event: ErrorEvent) => {
      handleError(event.error?.message || 'A critical runtime error occurred.')
    }

    window.addEventListener('unhandledrejection', handleRejection)
    window.addEventListener('error', handleRuntimeError)

    return () => {
      window.removeEventListener('unhandledrejection', handleRejection)
      window.removeEventListener('error', handleRuntimeError)
    }
  }, [handleError])

  return {
    globalErrorInfo,
    dismissGlobalError
  }
}
